import { ApplePayComponent } from '../components/digitalWallets/applePayComponent';
import { ClickToPayComponent } from '../components/digitalWallets/clickToPayComponent';
import { GooglePayComponent } from '../components/digitalWallets/googlePayComponent';

export const DigitalWallets = {
	ApplePayComponent,
	ClickToPayComponent,
	GooglePayComponent,
};
